<template>
	<div class="userinfo-wrap">
		<div class="userinfo">
			<div class="userinfo-l" @click.stop="toUserIndex(item.userId)">
				<img :src="item.headPic?item.headPic:require('@/assets/default-avatar.png')"/>
			</div>
			<div class="userinfo-r">
				<div class="username-wrap" @click.stop="toUserIndex(item.userId)">
					<div class="username">{{item.nickName}}</div>
					<div class="level" v-if="item.circleLevel">
						<img :src="item.circleLevel">
					</div>
				</div>
				<div v-if="item.userClass == 1" class="user-type">官方账号</div>
				<!-- <div class="userinfo-tips" @click.stop="toCircleIndex(item.circleId)">{{item.circleName}}</div> -->
			</div>
		</div>
		<div v-if="userId!=item.userId && !activePath.includes('home')  && !activePath.includes('circleIndex')">
			<div v-if="item.isFollow==1" class="follow-btn followed" @click.stop="toFollow(item)">+ 已关注</div>
			<div v-else class="follow-btn" @click.stop="toFollow(item)">+ 关注</div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'userinfo',
		components: {},
		props: {
			item: {
				type: Object,
				value: {}
			},
			isShowFollow: {
				type: Boolean,
				value: false
			}
		},
		data() {
			return {
				userId: '',
				activePath: '',
			}
		},
		created(){
			this.userId = localStorage.getItem('userId')
			this.activePath = this.$route.fullPath
		},
		methods: {
			//关注 取消关注
			async toFollow(item){
				if(!this.userId){
					this.$router.push({
						path: '/login'
					})
					return
				}
				let param = {
					userId: this.userId,
					followUserId: item.userId,
					followFlag: item.isFollow==1?0:1
				}
				ajaxParam(param)
				const res = await post('v1/circle/followUser', qs.stringify(param))
				if(res.data.code==200){
					console.log(res.data)
					if(item.isFollow==1) {
						this.$message.success('取消关注成功！')
					} else {
						this.$message.success('关注成功！')
					}
					item.isFollow = item.isFollow==1?0:1

				} else {
					this.$message.error(res.data.msg)
				}
			},
			toCircleIndex(id){
				this.$router.push({
					path: '/circleIndex?id='+id
				})
			},
			toUserIndex(id){
				this.$router.push({
					path: '/userIndex?id='+id
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.userinfo-wrap {
		display: flex;
		justify-content: space-between;

		.userinfo {
			display: flex;

			.userinfo-l img {
				width: 40px;
				height: 40px;
				border-radius: 50%;
			}

			.userinfo-r {
				margin: auto;
				margin-left: 6px;

				.username-wrap {
					display: flex;
					align-items: center;

					.username {
						font-size: 16px;
						font-weight: bold;
					}
				}

				.user-type {
					display: inline-block;
					max-width: 60px;
					height: 18px;
					padding: 0 4px!important;
					background: rgba(247, 125, 42, .18);
					border-radius: 4px;
					color: #F77D2A;
					font-size: 12px;
					line-height: 18px;
					text-align: center;
					margin-top: 2px;
				}

				.level{
					margin-left:5px;
					img{
						height:16px;
						margin-top: 0;
					}
				}

				.userinfo-tips {
					margin-top: 2px;
					opacity: .7;
					font-size: 12px;
					cursor: pointer;
				}
			}
		}
	}
</style>
